export default {
  env: process.env.NODE_ENV,
  lang: 'th'
}

export const PerPage = () => {
  return [10,25,50,100,250,500];
};